import React from 'react';
import { useSelector } from 'react-redux';

import * as ActiveProductSelectors from 'selectors/ActiveProductSelectors';

import ConnectInventory from './ConnectInventory';
import PackageAvailability from './PackageAvailability';

const Availability = () => {
	const product = useSelector(ActiveProductSelectors.productDataWithChanges);

	if (product.set) return <PackageAvailability />;
	else return <ConnectInventory />;
};

export default Availability;
